var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxqqrss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "356.15125mm",
    height: "98.016365mm",
    viewBox: "0 0 356.15125 98.016365",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826126e-7,-198.98364)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path506",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    d: "M 29.104245,272.34558 C 27.179998,270.66186 24.534157,269.82 21.407255,269.82 9.5009732,269.82 9.0826126e-7,278.59938 9.0826126e-7,287.98009 9.0826126e-7,293.63257 4.5700889,297 10.463097,297 c 9.621238,0 21.52752,-9.01991 21.52752,-18.16009 v -79.61574 h -2.886372 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path508",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    d: "m 108.96804,272.34558 c -1.92425,-1.56345 -4.57009,-2.52558 -7.69699,-2.52558 -11.906284,0 -21.407257,8.77938 -21.407257,18.16009 0,5.65248 4.570088,9.01991 10.463096,9.01991 9.621238,0 21.407251,-9.01991 21.527521,-18.03982 v -79.97654 h -2.88637 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path510",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    d: "m 111.33952,198.98364 v 12.02655 h 30.06637 v 5.893 h -30.06637 v 12.02655 h 30.06637 v 43.29557 c -1.92425,-1.56345 -4.57009,-2.52557 -7.69699,-2.52557 -11.90628,0 -21.40725,8.77938 -21.40725,18.16008 0,5.65248 4.57009,9.01991 10.46309,9.01991 9.62124,0 21.40726,-8.89964 21.52752,-18.03982 v -79.85627 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path512",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    d: "m 211.57891,252.09294 c 1.56345,1.92424 2.88637,3.84849 4.20929,5.77274 0.12027,0.48106 0.60133,1.20265 0.60133,1.44318 0,0 0,0.24053 -0.12026,0.3608 -0.24054,0.3608 -0.60133,0.48106 -1.08239,0.48106 -0.3608,0 -1.20266,-0.24053 -1.56345,-0.36079 -0.48107,0 -1.08239,-0.24054 -1.56346,-0.24054 -4.08902,0 -7.81725,4.08903 -7.81725,9.26045 0,4.81061 4.08902,9.50097 11.18469,14.91291 0.72159,0.60133 1.68371,0.84186 2.40531,0.84186 0.72159,0 1.44318,-0.24053 1.44318,-0.60132 0.12027,-0.24054 0.24053,-0.48107 0.24053,-0.60133 0,-0.96213 -0.72159,-1.68372 -1.56345,-2.40531 -1.20265,0 -2.28504,-2.52558 -2.52557,-3.36743 -0.24053,-0.84186 -0.3608,-1.68372 -0.3608,-2.52558 0,-3.00664 1.44319,-6.37407 4.57009,-6.9754 0.48106,-0.12026 0.96212,-0.12026 1.56345,-0.12026 2.76611,0 5.89301,1.08239 7.45646,1.68371 0.12026,0 0.24053,0.12027 0.24053,0.12027 0.3608,0.12027 0.48106,0.12027 0.72159,0.12027 0.24053,0 0.48106,-0.12027 0.48106,-0.48107 0,-1.08239 -2.52557,-4.32955 -3.60796,-5.41194 -3.60796,-4.44983 -6.6146,-8.05779 -6.6146,-13.34947 0,-0.48106 0.12027,-0.96212 0.12027,-1.32292 0.36079,-5.53221 3.84849,-10.22257 6.37407,-14.07106 0.24053,-0.48106 0.36079,-0.96212 0.36079,-1.44319 0,-0.96212 -0.36079,-1.92424 -0.36079,-1.92424 0,0 -14.3116,-16.83717 -15.87505,-18.52089 -0.48106,-0.48106 -1.20265,-0.72159 -1.80398,-0.72159 -0.96212,0 -1.92425,0.60133 -1.92425,1.92425 0,0.48106 0.12027,0.96212 0.48106,1.56345 0.3608,1.08239 5.77275,6.01327 5.77275,12.8684 0,3.60797 -1.44319,7.69699 -5.77275,12.26708 -0.96212,0.96213 -1.32292,2.04452 -1.32292,2.76611 0,1.32292 0.96213,2.28504 0.96213,2.28504 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path514",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    d: "m 271.27945,272.34558 c -1.92425,-1.56345 -4.57009,-2.52558 -7.69699,-2.52558 -11.90629,0 -21.40726,8.77938 -21.40726,18.16009 0,5.65248 4.57009,9.01991 10.4631,9.01991 9.62124,0 21.40725,-9.01991 21.52752,-18.03982 v -79.97654 h -2.88637 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path516",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    d: "m 273.65094,198.98364 v 12.02655 h 30.06637 v 5.893 h -30.06637 v 12.02655 h 30.06637 v 43.29557 c -1.92425,-1.56345 -4.57009,-2.52557 -7.69699,-2.52557 -11.90628,0 -21.40726,8.77938 -21.40726,18.16008 0,5.65248 4.57009,9.01991 10.4631,9.01991 9.62124,0 21.40725,-8.89964 21.52752,-18.03982 v -79.85627 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g241",
    transform: "translate(176.89285,16.92532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 151.92144,280.07468 h -7.79057 v -9.29002 h 7.79057 z",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 165.58992,280.07468 h -7.79057 v -9.29002 h 7.79057 z",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 179.2584,280.07468 h -7.79057 v -9.29002 h 7.79057 z",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    id: "path232"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": ",",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "76.76551819px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.91913795
    },
    id: "text283",
    transform: "matrix(0.37839078,0,0,0.37839078,72.284899,242.53376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 240.56434,119.39031 -10.57025,24.55147 h -5.47254 l 6.52207,-24.55147 z",
    style: {
      strokeWidth: 1.91913795
    },
    id: "path285"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxqqrss);
export default __webpack_public_path__ + "static/media/cxqqrss.a3931aff1b286f5d7bdad27e7fb8cac6.svg";
export { ForwardRef as ReactComponent };